import { useContext } from 'react'
import { AuthContext } from './context'
import type { AuthValue } from './context'

export function useAuth(): AuthValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>')
  return ctx
}

/** Narrowed helper for code paths that already know the user is signed in. */
export function useCurrentUserId(): string {
  const { user } = useAuth()
  if (!user) throw new Error('expected an authenticated user')
  return user.id
}
